import ThreadCrmTicketUpdatedMessage from './ThreadCrmTicketUpdatedMessage';
import ThreadCrmTicketAssociationUpdateMessage from './ThreadCrmTicketAssociationUpdateMessage';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'conv... Remove this comment to see the full error message
import { isTicketAssociationUpdateType } from 'conversations-message-history/crm-object-lifecycle-update/operators/isTicketAssociationUpdateType';
import { jsx as _jsx } from "react/jsx-runtime";
const ThreadCrmTicketUpdateLabel = ({
  message,
  senders,
  userId,
  portalId,
  onTicketLinkClick = () => {}
}) => /*#__PURE__*/_jsx("div", {
  children: isTicketAssociationUpdateType(message) ? /*#__PURE__*/_jsx(ThreadCrmTicketAssociationUpdateMessage, {
    message: message,
    senders: senders,
    userId: userId,
    portalId: portalId,
    onTicketLinkClick: onTicketLinkClick
  }) : /*#__PURE__*/_jsx(ThreadCrmTicketUpdatedMessage, {
    message: message,
    senders: senders,
    userId: userId
  })
});
ThreadCrmTicketUpdateLabel.displayName = 'ThreadCrmTicketUpdateLabel';
export default ThreadCrmTicketUpdateLabel;